import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchSalutationData = createAsyncThunk(
  "api/salutation",
  async () => {
    const response = await fetch(`${FULL_API_BASE_URL}/get-salutation/`);
    const data = await response.json();
    return data;
  }
);

const departmentSlice = createSlice({
  name: "salutation",
  initialState: {
    salutationdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalutationData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSalutationData.fulfilled, (state, action) => {
        state.loading = false;
        state.salutationdata = action.payload;
      })
      .addCase(fetchSalutationData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default departmentSlice.reducer;
